import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface ToastState {
  message: string;
  visible: boolean;
}

interface ToastContextValue {
  showToast: (message: string) => void;
}

const ToastContext = createContext<ToastContextValue>({ showToast: () => {} });

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<ToastState>({ message: '', visible: false });

  const showToast = useCallback((message: string) => {
    setToast({ message, visible: true });
    window.setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, 2200);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div
        className={`pointer-events-none fixed left-1/2 top-20 z-[100] -translate-x-1/2 transition-all duration-300 ${
          toast.visible ? 'translate-y-0 opacity-100' : '-translate-y-3 opacity-0'
        }`}
      >
        <div className="flex items-center gap-2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50 shadow-lg">
          <i className="ri-check-line text-accent-400"></i>
          <span>{toast.message}</span>
        </div>
      </div>
    </ToastContext.Provider>
  );
}